export class CanadaReportBuildItem {
  ReportType: string;
  StartDate: string;
  EndDate: string;
  TemplateName: string;
  SaveHistoricalData: boolean=false;
  DeptNum: string;
}
